import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// ResizeObserver loop errors are harmless browser noise produced by dynamic
// dialogs/modals. Suppress them before React's dev error overlay picks them up.
// window.onerror runs BEFORE addEventListener listeners (incl. CRA's overlay),
// so this reliably prevents the blocking red screen in development.
const _resizeObserverErrMsg = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
];
const _origOnerror = window.onerror;
window.onerror = function(message) {
  if (_resizeObserverErrMsg.some(msg => message?.includes(msg))) {
    return true; // suppressed — return true = "error handled", no overlay
  }
  return _origOnerror?.apply(window, arguments) ?? false;
};
// Belt-and-suspenders: also stop the event from propagating (for older CRA versions)
window.addEventListener('error', (e) => {
  if (_resizeObserverErrMsg.some(msg => e.message?.includes(msg))) {
    e.stopImmediatePropagation();
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service Worker registrieren (PWA – "Add to Homescreen" Support)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Merken ob VORHER schon ein SW aktiv war (für Reload-Loop-Prävention)
    const hadControllerBeforeRegister = !!navigator.serviceWorker.controller;

    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('[PWA] Service Worker registriert:', registration.scope);

        // Android-PWA: Bei App-Foreground aktiv auf neuen Service Worker prüfen.
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            registration.update().catch(() => {});
          }
        });

        // Neuer SW-Controller: NIEMALS automatisch reloaden!
        // iOS-Bug: Der Datei-Picker schickt die PWA in den Hintergrund. Beim
        // Zurückkehren wurde registration.update() + sofortiger Reload
        // ausgelöst → laufende Dateiauswahl/Upload wurde zerstört.
        // Stattdessen: Update-Hinweis anzeigen, Nutzer entscheidet.
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (!hadControllerBeforeRegister) {
            console.log('[PWA] Service Worker erstmals aktiv – kein Reload nötig');
            return;
          }
          console.log('[PWA] Neuer Service Worker aktiv – Update-Hinweis');
          window.__swUpdatePending = true;
          window.dispatchEvent(new CustomEvent('allflowx-sw-updated'));
        });
      })
      .catch((error) => {
        console.warn('[PWA] Service Worker Registration fehlgeschlagen:', error);
      });
  });
}
